/**
 * カードの色
 */
export enum CardColor {
  RED = 'red',
  BLUE = 'blue',
  YELLOW = 'yellow',
  WILD = 'wild'
}

/**
 * カードのタイプ
 */
export enum CardType {
  NUMBER = 'number',
  SKIP = 'skip',
  REVERSE = 'reverse',
  DRAW_TWO = 'draw_two',
  WILD = 'wild',
  WILD_DRAW_FOUR = 'wild_draw_four'
}

/**
 * カードインターフェース
 */
export interface Card {
  /** ユニークID */
  id: string;
  /** カード色 */
  color: CardColor;
  /** カードタイプ */
  type: CardType;
  /** 数字カードの値（0-9） */
  value?: number;
}
